<template>
	<div id="ColumnContainer">
		<slot/>
	</div>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';

	@Component({
		components: {
		},
	})
	export default class ColumnContainer extends Vue {
	}
</script>

<style lang="scss">
#ColumnContainer {
	display: flex;
	flex-direction: row;
	
	width: 100%;
	height: 100%;
	overflow: hidden;
}
</style>